import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { PDAUser } from '../models/pda_User';
import { PDAUserType } from '../models/pda_User_Type';
import { Guid } from 'guid-typescript';


@Injectable()
export class PDAUserService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public get(user_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log(user_Id);
      this.http.get<any>(environment.apiUrl + 'pdaUser/get?user_Id=' + user_Id).subscribe(data => {
        console.log(data);
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getAllUserTypes(): Promise<PDAUserType[]> {

    return new Promise((resolve, reject) => {
      this.http.get<PDAUserType[]>(environment.apiUrl + 'pdaUser/getAllUserTypes').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }

  public getAll(): Promise<PDAUser[]> {
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<PDAUser[]>(environment.apiUrl + 'pdaUser/GetAll').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(pdaUser: PDAUser): Promise<any> {

    pdaUser.company_Id = Number(pdaUser.company_Id);
    pdaUser.pda_User_Type_Id = Number(pdaUser.pda_User_Type_Id);

    if (pdaUser.company_Id == 0) {
      this.snotifyService.error('Please select a company');
      return;
    }

    if (pdaUser.pda_User_Type_Id == 0) {
      this.snotifyService.error('Please select a user type');
      return;
    }

    if (pdaUser.android_Pin != pdaUser.confirm_Android_Pin) {
      this.snotifyService.error("Pin doesn't match. Please ensure both pins are identical", { timeout: 8000 });
      return;
    }

    var checkPassWordCharacters = /^[a-zA-Z~_&*%@$]+$/;
    if (checkPassWordCharacters.test(pdaUser.android_Pin)) {
      this.snotifyService.error("Pin should only contain numbers", { timeout: 8000 });
      return;
    }

    return new Promise((resolve, reject) => {
      console.log(pdaUser);
      if (pdaUser.is_edit) {
        this.http.put<any>(environment.apiUrl + 'pdaUser/put', pdaUser).subscribe(data => {
          resolve(data);
          if (data.success) {
            this.snotifyService.success('Successfully edited tablet user');
          }
          else {
            this.snotifyService.error('Failed to add tablet user', { timeout: 4000 });

            switch (data.message) {
              case "Email":
                this.snotifyService.error('Email already exists', { timeout: 4000 });
                break;
              case "Password":
                this.snotifyService.error('Password failed to save', { timeout: 4000 });
                break;
            }
          }
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        pdaUser.created_Date = "1970-01-01T00:00:00";
        this.http.post<any>(environment.apiUrl + 'pdaUser/post', pdaUser).subscribe(data => {
          resolve(data);
          console.log(data);
          if (data.success) {
            this.snotifyService.success('Successfully added tablet user');
          }
          else {
            switch (data.message) {
              case "Email":
                this.snotifyService.error('Email already exists', { timeout: 4000 });
                break;
              case "Password":
                this.snotifyService.error('Password failed to save', { timeout: 4000 });
                break;
              case "MaxLicences":
                this.snotifyService.error('You have exceeded your license count, please contact CoreRFID', { timeout: 4000 });
                break;
              default:
                this.snotifyService.error('Failed to add tablet user', { timeout: 4000 });
                break;
            }
          }
          
        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, username: string, company_Id: number, quick_Search: string): Promise<PagedData<PDAUser>> {
    const pagedData = new PagedData<PDAUser>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'PDA_User_Id'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&username=' + username;
      params += '&company_Id=' + company_Id;
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'pdaUser/getTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getExcel(page: Page, username: string, company_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'PDA_User_Id'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '?username=' + username;
      params += '&company_Id=' + company_Id;
      params += '&sortBy=' + page.sortBy;
      params += '&sortOrder=' + page.sortOrder;

      this.http.get<any>(environment.apiUrl + 'pdaUser/getExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }



  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
